<template>
	<div class="maintenancebanner" v-if="$store.main.maintenance">
		<Icon name="alert" />
		<div class="content">
			<p v-if="remaining > 0" v-html="$t('maintenance.banner', {TIME:lockTime, DURATION:remainingFormatted})"></p>
			<p v-else-if="$store.auth.isAdmin">{{ $t("maintenance.banner_admin") }}</p>
			<p v-else>{{ $t("maintenance.banner_now") }}</p>
			<p class="message" v-if="message">{{ message }}</p>
		</div>
	</div>
</template>

<script lang="ts">
import Utils from '@/utils/Utils';
import { Component, Vue, toNative } from 'vue-facing-decorator';
import Icon from '../Icon.vue';

@Component({
	components:{
		Icon,
	},
	emits:[],
})
class MaintenanceBanner extends Vue {

	public now:number = Date.now();

	private refreshInterval:number = -1;

	public get remaining():number {
		const maintenance = this.$store.main.maintenance;
		if(!maintenance) return 0;
		return Math.max(0, maintenance.lockAt - this.now);
	}

	public get remainingFormatted():string {
		return Utils.formatDuration(this.remaining, true);
	}

	/**
	 * Message in user's language, english as a fallback
	 */
	public get message():string {
		const texts = this.$store.main.maintenance?.message;
		if(!texts) return "";
		return texts[this.$i18n.locale] || texts["en"] || "";
	}

	public get lockTime():string {
		const maintenance = this.$store.main.maintenance;
		if(!maintenance) return "";
		return Utils.formatDate(new Date(maintenance.lockAt), true, true);
	}

	public mounted():void {
		this.refreshInterval = window.setInterval(()=> {
			this.now = Date.now();
		}, 1000);
	}

	public beforeUnmount():void {
		window.clearInterval(this.refreshInterval);
	}

}
export default toNative(MaintenanceBanner);
</script>

<style scoped lang="less">
.maintenancebanner{
	gap: .5em;
	top: .5em;
	left: 50%;
	z-index: 100;
	display: flex;
	position: fixed;
	align-items: center;
	flex-direction: row;
	max-width: calc(100% - 1em);
	width: max-content;
	padding: .5em 1em;
	border-radius: var(--border-radius);
	transform: translateX(-50%);
	color: var(--color-light);
	background-color: var(--color-alert);
	box-shadow: 0 0 .5em rgba(0, 0, 0, .5);
	pointer-events: none;

	.icon {
		height: 1.5em;
		flex-shrink: 0;
	}

	.content {
		gap: .25em;
		display: flex;
		flex-direction: column;
		line-height: 1.25em;
		white-space: pre-line;
		.message {
			font-style: italic;
			white-space: pre-line;
		}
	}
}
</style>
